import React, { useEffect } from "react";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import { ReactComponent as ExportIcon } from "../../../assets/icons/export.svg";
import { ReactComponent as FilterIcon } from "../../../assets/icons/sort.svg";
import { ReactComponent as RefreshIcon } from "../../../assets/icons/refresh.svg";
import useDebounce from "../../Hooks/useDebounce";
import SearchBar from "../Common/Search/SearchBar";
import BaseButton from "../Common/Buttons/BaseButton";
import { commonStyles } from "../../../assets/MUIStyles/commonStyles";
import { setEncryptedItem } from "../../../utils/localStorageHelper";

const CallHistoryHeader = ({
  setIsReady,
  setSearchText,
  exportToCSV,
  toggleFilterDrawer,
  totalCalls,
  exportLoad,
  searchTerm,
  setSearchTerm,
  applyRefresh,
  loading,
  setCurrentPage
}) => {
  const debouncedSearchTerm = useDebounce(searchTerm, 3000);

  useEffect(() => {
    setIsReady(true);
    setSearchText(debouncedSearchTerm);
    setCurrentPage(1);
    setEncryptedItem("callHistorySearchTerm", debouncedSearchTerm);
  }, [debouncedSearchTerm]);

  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        justifyContent: "space-between",
        marginBottom: 2,
      }}
    >
      <Box
        className="flex-xy-center"
        sx={{
          gap: 2,
        }}
      >
        <Typography className="font-20-grey">Call History</Typography>
        <Typography
          className="font-14-lightgrey"
          component="span"
          sx={commonStyles.textInfo}
        >
          Total calls{" "}
          <span className="font-20-700-lightgrey">{totalCalls || 0}</span>
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          gap: 1,
        }}
      >
        <SearchBar
          searchText={searchTerm}
          handleChange={(e) => setSearchTerm(e.target.value)}
        />
        <BaseButton
          title="Export"
          variant="outlined"
          startIcon={<ExportIcon height={14} width={14} />}
          loading={exportLoad}
          handleClick={exportToCSV}
          styles={{ px: 2, fontSize: 12 }}
        />
        <IconButton
          title="Refresh"
          onClick={applyRefresh}
          sx={commonStyles.refreshButtonStyle}
          disabled={loading}
        >
          <RefreshIcon className="refresh-icon" height={14} width={14} />
        </IconButton>
        <IconButton
          title="Apply Filters"
          onClick={toggleFilterDrawer}
          sx={commonStyles.filterButtonStyle}
        >
          <FilterIcon />
        </IconButton>
      </Box>
    </Stack>
  );
};

export default CallHistoryHeader;
